export default __webpack_public_path__ + "static/media/Bedroom_V.3.6e795852.jpg";